'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChoroplethLegend = exports.ChoroplethChart = exports.StackedRowChart = exports.StackedBarChart = exports.HorizontalSymbolChart = exports.VerticalSymbolChart = exports.TimelineChart = exports.SymbolChart = exports.LineChart = exports.ScatterChart = exports.RowChart = exports.BarChart = undefined;
var _react = require('react');
var _reactChartFactory = require('./react-chart-factory');
var _reactChartFactory2 = _interopRequireDefault(_reactChartFactory);
var _dotstatsuiteD3Charts = require('@sis-cc/dotstatsuite-d3-charts');
var rcwCharts = _interopRequireWildcard(_dotstatsuiteD3Charts);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var BarChart = exports.BarChart = (0, _react.createFactory)((0, _reactChartFactory2.default)(rcwCharts.BarChart));
var RowChart = exports.RowChart = (0, _react.createFactory)((0, _reactChartFactory2.default)(rcwCharts.RowChart));
var ScatterChart = exports.ScatterChart = (0, _react.createFactory)((0, _reactChartFactory2.default)(rcwCharts.ScatterChart));
var LineChart = exports.LineChart = (0, _react.createFactory)((0, _reactChartFactory2.default)(rcwCharts.LineChart));
var SymbolChart = exports.SymbolChart = (0, _react.createFactory)((0, _reactChartFactory2.default)(rcwCharts.SymbolChart));
var TimelineChart = exports.TimelineChart = (0, _react.createFactory)((0, _reactChartFactory2.default)(rcwCharts.TimelineChart));
var VerticalSymbolChart = exports.VerticalSymbolChart = (0, _react.createFactory)((0, _reactChartFactory2.default)(rcwCharts.VerticalSymbolChart));
var HorizontalSymbolChart = exports.HorizontalSymbolChart = (0, _react.createFactory)((0, _reactChartFactory2.default)(rcwCharts.HorizontalSymbolChart));
var StackedBarChart = exports.StackedBarChart = (0, _react.createFactory)((0, _reactChartFactory2.default)(rcwCharts.StackedBarChart));
var StackedRowChart = exports.StackedRowChart = (0, _react.createFactory)((0, _reactChartFactory2.default)(rcwCharts.StackedRowChart));
var ChoroplethChart = exports.ChoroplethChart = (0, _react.createFactory)((0, _reactChartFactory2.default)(rcwCharts.ChoroplethChart));
var ChoroplethLegend = exports.ChoroplethLegend = (0, _react.createFactory)((0, _reactChartFactory2.default)(rcwCharts.ChoroplethLegend));